import styles from "./RichTextBlock.module.css";
import gridStyle from "./Grid.module.css";
import classNames from "classnames/bind";
export default function RichTextBlock({ value }) {
  return (
    <div className={classNames(styles.RichTextBlock, gridStyle.grid)}>
      <div
        className={styles.inner}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    </div>
  );
}
